import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedcoreModule } from './sharedcore.module';
import { UserFormComponent } from './users/user-form/new-user-form.component';
import { UserFormEditComponent } from './users/user-form/user-form-edit/user-form-edit.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { RestrictUserComponent } from './users/app-restrictions/restrict-user/restrict-user.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NguCarouselModule } from '@ngu/carousel';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ButtonsModule } from 'ngx-bootstrap';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { BusyLoaderComponent } from './shared/busy-loader/busy-loader.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@NgModule({
  imports: [
    SharedcoreModule,
    InfiniteScrollModule,
    BsDropdownModule.forRoot(),
    NguCarouselModule,
    ButtonsModule.forRoot(),
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    ConfirmationPopoverModule.forRoot(),
    TabsModule.forRoot(),
    AccordionModule.forRoot(),
    TypeaheadModule.forRoot(),
    SwiperModule.forChild(),
    FlexLayoutModule,
  ],
  declarations: [
    UserFormComponent,
    BusyLoaderComponent,
    UserFormEditComponent,
    RestrictUserComponent
  ],
  exports: [
    BsDropdownModule,
    ModalModule,
    NguCarouselModule,
    ButtonsModule,
    TooltipModule,
    ConfirmationPopoverModule,
    UserFormComponent,
    BusyLoaderComponent,
    InfiniteScrollModule,
    UserFormEditComponent,
    TabsModule,
    AccordionModule,
    TypeaheadModule,
    RestrictUserComponent
  ]
})

export class SharedModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/shared.module.ts